(() => {
  'use strict';

  const MOBILE_QUERY = '(max-width: 798px)';
  const ACTIVE_CLASS = 'b2-search-only-sticky';
  const PLACEHOLDER_CLASS = 'b2-mobile-inline-search-placeholder';
  const SENTINEL_CLASS = 'b2-mobile-search-sentinel';
  const HEIGHT_VAR = '--b2-mobile-search-placeholder-height';

  window.B2SearchOnlySticky = window.B2SearchOnlySticky || {};
  const manager = window.B2SearchOnlySticky;

  function cleanupBindings() {
    if (manager.scrollHandler) {
      window.removeEventListener('scroll', manager.scrollHandler);
      manager.scrollHandler = null;
    }
    if (manager.resizeHandler) {
      window.removeEventListener('resize', manager.resizeHandler);
      manager.resizeHandler = null;
    }
    if (manager.resizeObserver) {
      manager.resizeObserver.disconnect();
      manager.resizeObserver = null;
    }
  }

  function init() {
    cleanupBindings();

    const body = document.body;
    const header = document.getElementById('header');
    const search = header && header.querySelector('[data-b2-mobile-inline-search]');

    if (!body || !header || !search) return;

    const media = window.matchMedia(MOBILE_QUERY);

    header.querySelectorAll('.' + SENTINEL_CLASS + ', .' + PLACEHOLDER_CLASS).forEach((node) => node.remove());

    const sentinel = document.createElement('span');
    sentinel.className = SENTINEL_CLASS;
    sentinel.setAttribute('aria-hidden', 'true');

    const placeholder = document.createElement('div');
    placeholder.className = PLACEHOLDER_CLASS;
    placeholder.setAttribute('aria-hidden', 'true');

    search.insertAdjacentElement('beforebegin', sentinel);
    search.insertAdjacentElement('afterend', placeholder);

    let anchorY = 0;
    let normalHeight = 0;
    let active = false;
    let ticking = false;

    const measureNormalState = () => {
      if (!media.matches || active || body.classList.contains('is-active')) return;

      const searchRect = search.getBoundingClientRect();
      const sentinelRect = sentinel.getBoundingClientRect();

      if (searchRect.height <= 0) return;

      normalHeight = searchRect.height;
      anchorY = sentinelRect.top + window.scrollY;
      body.style.setProperty(HEIGHT_VAR, normalHeight.toFixed(2) + 'px');
    };

    const activate = () => {
      if (active) return;
      if (!normalHeight) measureNormalState();
      if (normalHeight) {
        body.style.setProperty(HEIGHT_VAR, normalHeight.toFixed(2) + 'px');
      }
      active = true;
      body.classList.add(ACTIVE_CLASS);
    };

    const deactivate = () => {
      if (!active) return;
      active = false;
      body.classList.remove(ACTIVE_CLASS);
      window.requestAnimationFrame(measureNormalState);
    };

    const update = () => {
      ticking = false;

      if (!media.matches) {
        deactivate();
        return;
      }

      if (body.classList.contains('is-active')) {
        deactivate();
        return;
      }

      if (!anchorY) measureNormalState();

      if (window.scrollY >= anchorY) {
        activate();
      } else {
        deactivate();
      }
    };

    const scheduleUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    manager.scrollHandler = scheduleUpdate;
    manager.resizeHandler = () => {
      if (active) deactivate();
      window.requestAnimationFrame(() => {
        measureNormalState();
        update();
      });
    };

    window.addEventListener('scroll', manager.scrollHandler, { passive: true });
    window.addEventListener('resize', manager.resizeHandler);

    if ('ResizeObserver' in window) {
      manager.resizeObserver = new ResizeObserver(() => {
        if (!active) {
          measureNormalState();
          scheduleUpdate();
        }
      });
      manager.resizeObserver.observe(search);
    }

    measureNormalState();
    update();
    window.setTimeout(() => {
      measureNormalState();
      update();
    }, 250);
    window.setTimeout(() => {
      measureNormalState();
      update();
    }, 1000);
  }

  manager.init = init;
  manager.cleanup = cleanupBindings;

  if (!manager.baseListenersBound) {
    manager.baseListenersBound = true;

    window.addEventListener('pageshow', () => manager.init());

    document.addEventListener('shopify:section:load', () => {
      window.setTimeout(() => manager.init(), 0);
    });

    if (window.InstantClick && typeof window.InstantClick.on === 'function') {
      window.InstantClick.on('change', () => {
        window.setTimeout(() => manager.init(), 0);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => manager.init(), { once: true });
  } else {
    manager.init();
  }
})();
